import { createFileRoute } from "@tanstack/react-router";
import { RewardPage } from "@/projects/admin/pages/RewardPage";

export const Route = createFileRoute("/admin/reward")({
  head: () => ({ meta: [{ title: "Ready for Reward — Admin" }] }),
  component: RewardPage,
});
